import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faLayerGroup, faToolbox, faUserGroup, faCommentDollar, faTableCellsLarge, IconDefinition } from '@fortawesome/free-solid-svg-icons';

interface Props {
  access: any;
}

// Нижняя таб-панель мобильной версии (по концепту designs/mobile-design-preview.html):
// Главная · Таймшит · [＋ FAB] · Уведомления · Ещё. Остальные разделы — внутри «Ещё».
const MobileTabBar: React.FC<Props> = ({ access }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  const Tab = ({ path, icon, label }: { path: string; icon: IconDefinition; label: string }) => (
    <button type="button" className={`m-tab${isActive(path) ? ' on' : ''}`} onClick={() => navigate(path)}>
      <FontAwesomeIcon icon={icon} className="m-ic" />
      <span>{t(label)}</span>
    </button>
  );

  return (
    <nav className="m-tabbar">
      <Tab path="/dashboard" icon={faHouse} label="Dashboard" />
      <Tab path="/timesheets" icon={faLayerGroup} label="Timesheets" />
      {access?.equipment_enabled === true && <Tab path="/equipment" icon={faToolbox} label="Equipment" />}
      {access?.hr_enabled === true && <Tab path="/hr" icon={faUserGroup} label="HR" />}
      {access?.finance_enabled === true && <Tab path="/finance" icon={faCommentDollar} label="Finance" />}
      <Tab path="/more" icon={faTableCellsLarge} label="More" />
    </nav>
  );
};

export default MobileTabBar;
